import "../../css/VaultAccess/vault_access_filters.css";
import { Dropdown } from "primereact/dropdown";
import { useState, useEffect, useRef } from "react";
import { GetParameters } from "../../api/getParameter"; 
import { useFilters } from "../../context/FilterContext";
import { CSSTransition } from "react-transition-group";
import { motion } from "framer-motion";
import CustomerSelection from "../../components/Common/CustomerSelection";

export default function VaultFilters({ loadedCount, totalCount }) {
	const { selectedFilters, updateFilter, selectedCategory, setSelectedCategory, clearAllFilters, products, hasMore, totalRecordCounts, sort, setSort, markProductInCart, markProductInEnquiry, refetchProducts, } = useFilters();
    const [sortValue, setSortValue] = useState(null);
    const [parameters, setParameters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [activeFilter, setActiveFilter] = useState(null);
    const [toasts, setToasts] = useState([]);
    const [filteredData, setFilteredData] = useState({});
    const [sortOptions, setSortOptions] = useState([]);
    const [selectedPrice, setSelectedPrice] = useState([0, 10000000]);
    const [priceInput, setPriceInput] = useState({ from: 0, to: 10000000 });
    const [selectedGoldWeight, setSelectedGoldWeight] = useState([0, 250]);
    const [goldInput, setGoldInput] = useState({ from: 0, to: 250 });
    const [selectedCarat, setSelectedCarat] = useState([0, 100]);
	const [caratInput, setCaratInput] = useState({ from: 0, to: 100 });
	const clamp = (val, min, max) => Math.min(Math.max(val, min), max);
    const isSortInitialized = useRef(false);
    const cacheRef = useRef({});
    const handleEnterApply = (e, applyFn) => {
        if (e.key === "Enter") {
            e.preventDefault();
            applyFn();
            e.target.blur();
        }
    };
    const min = 0;
    const max = 10000000;
    const step = 500;
    const minGoldWeight = 0;
    const maxGoldWeight = 250;
    const stepGoldWeight = 1;
    const minCarat = 0;
    const maxCarat = 100;
    const stepCarat = 1;
	const [copied, setCopied] = useState(false);
	const activeTags = [];

    const showToast = (toastData) => {
        setToasts(prev => [...prev, { id: Date.now(), ...toastData }]);
    };

    const removeToast = (id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    };
	const filters = [
		"Metal Tone",
		"Gold Quality",
		"Price",
		"Carat",
		"Gold Weight",
		"Item Size",
		"By Ring Style"
	];

    const filterMapping = {
        "Metal Tone": "METALTONE",
        "Gold Quality": "GOLDKT",
        Price: "PRICE",
        "Carat": "Carat",
        "Gold Weight": "GOLDWEIGHT",
        "Item Size": "ITEMSIZE",
        "Ring Style": "RING_STYLE"
    };

	const handleMinChange = (e) => {
		const newVal = Number(e.target.value);
		const updatedRange = [newVal, selectedPrice[1]];
		setSelectedPrice(updatedRange);
		setPriceInput(prev => ({ ...prev, from: newVal }));
		updateFilter("Price", { from: newVal, to: selectedPrice[1] });
	};

	const handleMaxChange = (e) => {
		const newVal = Number(e.target.value);
		const updatedRange = [selectedPrice[0], newVal];
		setSelectedPrice(updatedRange);
		setPriceInput(prev => ({ ...prev, to: newVal }));
		updateFilter("Price", { from: selectedPrice[0], to: newVal });
	};

	const handleGoldWeightMinChange = (e) => {
		const newVal = Number(e.target.value);
		const updatedRange = [newVal, selectedGoldWeight[1]];
		setSelectedGoldWeight(updatedRange);
		setGoldInput(prev => ({ ...prev, from: newVal }));
		updateFilter("Gold Weight", { from: newVal, to: selectedGoldWeight[1] });
	};

	const handleGoldWeightMaxChange = (e) => {
		const newVal = Number(e.target.value);
		const updatedRange = [selectedGoldWeight[0], newVal];
		setSelectedGoldWeight(updatedRange);
		setGoldInput(prev => ({ ...prev, to: newVal }));
		updateFilter("Gold Weight", { from: selectedGoldWeight[0], to: newVal });
	};

	const handleCaratMinChange = (e) => {
		const newVal = Number(e.target.value);
		const updatedRange = [newVal, selectedCarat[1]];
		setSelectedCarat(updatedRange);
		setCaratInput(prev => ({ ...prev, from: newVal }));
		updateFilter("Carat", { from: newVal, to: selectedCarat[1] });
	};

	const handleCaratMaxChange = (e) => {
		const newVal = Number(e.target.value);
		const updatedRange = [selectedCarat[0], newVal];
		setSelectedCarat(updatedRange);
		setCaratInput(prev => ({ ...prev, to: newVal }));
		updateFilter("Carat", { from: selectedCarat[0], to: newVal });
	};

	if (selectedCategory) {
		activeTags.push({ key: `cat-${selectedCategory}`, type: "category", label: `${selectedCategory}`, filterKey: "category" });
	}

	Object.keys(selectedFilters).forEach((filterKey) => {
		const value = selectedFilters[filterKey];
		if (value === null || value === undefined) return;
		if (Array.isArray(value)) {
			value.forEach((item) => {
				activeTags.push({
					key: `${filterKey}-${item.value}`,
					type: "filter",
					filterKey: filterKey,
					label: item.label || item.value,
					value: item.value
				});
			});
		}
		else if (typeof value === 'object' && ('from' in value || 'to' in value)) {
			const from = Number(value.from) || 0;
			const to = Number(value.to) || 0;
			activeTags.push({
				key: `range-${filterKey}`,
				type: "range",
				filterKey: filterKey,
				label: `${from.toLocaleString()} - ${to.toLocaleString()}`
			});
		}
		else if (typeof value === 'string' && value.trim() !== "") {
			activeTags.push({
				key: `string-${filterKey}`,
				type: "filter",
				filterKey: filterKey,
				label: `${value}`
			});
		}
	});

	const removeTag = (tag) => {
		if (tag.type === "category") return setSelectedCategory(null);

		if (tag.type === "range") {
			updateFilter(tag.filterKey, null);
			return;
		}

		if (tag.type === "filter") {
			const current = selectedFilters[tag.filterKey];
			if (tag.filterKey === "By Ring Style") {
				updateFilter(tag.filterKey, "");
			}
			else if (Array.isArray(current)) {
				updateFilter(tag.filterKey, current.filter(x => x.value !== tag.value));
			} else {
				updateFilter(tag.filterKey, "");
			}
		}
	};
	useEffect(() => {
		if (!selectedFilters.Price) {
			setSelectedPrice([min, max]);
			setPriceInput({ from: min, to: max });
		}
		if (!selectedFilters["Gold Weight"]) {
			setSelectedGoldWeight([minGoldWeight, maxGoldWeight]);
			setGoldInput({ from: minGoldWeight, to: maxGoldWeight });
		}
		if (!selectedFilters.Carat) {
			setSelectedCarat([minCarat, maxCarat]);
			setCaratInput({ from: minCarat, to: maxCarat });
		}
	}, [selectedFilters]);


    const fetchParameters = async (category = "") => {
        setLoading(true);
        try {
            const payload = { CategoryList: category };
            const res = await GetParameters(payload);

            if (cacheRef.current[category]) {
                setFilteredData(cacheRef.current[category]);
                return;
            }

            if (res?.Message?.[0]?.RETURNCODE !== "1") {
                console.error("Error:", res?.Message?.[0]?.RETURNMESSAGE);
                setFilteredData({});
                setCategories([]);
                setSortOptions([]);
                return;
            }

            const params = res?.Parameters || [];
            const sortedParams = [...params].sort((a, b) => Number(a.SEQUENCENO || 0) - Number(b.SEQUENCENO || 0));

            const mapped = Object.keys(filterMapping).reduce((acc, key) => {
                const type = filterMapping[key];
                if (key === "Ring Style") return { ...acc, [key]: [] };
                acc[key] = sortedParams
                    .filter(p => p.PARATYPE?.toUpperCase() === type)
                    .map(p => ({ label: p.PARANAME, value: p.PARANAME }));
                return acc;
            }, {});
            if (mapped.Price?.length) {
                setSelectedPrice([min, max]);
            }
            setFilteredData(mapped);
            setCategories(sortedParams
                .filter(p => p.PARATYPE?.toUpperCase() === "CATEGORY")
                .map(c => ({
                    productId: c.PARANAME,
                    name: c.PARANAME.toUpperCase()
                }))
            );
            const incomingSorts = sortedParams
                .filter(p => p.PARATYPE?.toUpperCase() === "SORT")
                .map(c => ({ label: c.PARANAME, value: c.PARANAME }));

            setSortOptions(incomingSorts);

        } catch (error) {
            console.error("Failed to fetch parameters:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCategoryChange = (categoryName) => {
        setSelectedCategory(categoryName);
        fetchParameters(categoryName);
    };


    useEffect(() => {
        fetchParameters();
    }, []);

    return (
        <div className="vault-header-card">
            <div className="vault-header-row">
                <div className="vault-title">
                    <h2>Vault Access</h2>
                    <span> ({loadedCount} / {totalCount} items) </span>
                </div>
                <div className="vault-categories">
                    {categories.map((item) => (
                        <button key={item.productId} className={`category-btn ${selectedCategory === item.productId ? "active" : ""}`} onClick={() => handleCategoryChange(item.productId)}>
                            {item.name}
                        </button>
                    ))}
                </div>
            </div>

            <div className="vault-filter-card">
                <div className="vaultaccess-filters">
                    <div className="filters-header">
                        <div className="filters-left">
                            {filters.map(filterName => (
                                <div
                                    key={filterName}
                                    className={`filter-pill ${activeFilter === filterName ? "active" : ""}`}
                                    onClick={() => setActiveFilter(activeFilter === filterName ? null : filterName)}
                                >
                                    <span>{filterName}</span>
                                    <i className={`bx bx-chevron-${activeFilter === filterName ? "up" : "down"}`} />
                                </div>
                            ))}
                        </div>
                     
                        <div className="vaultaccess-action-group">
                            <button
                                type="button"
								className="btn-primary"
                                onClick={() => {
                                    setActiveFilter(null);
                                    refetchProducts();
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                }}
                            >
                                <span>Search</span>
                            </button>
                            <div className="sort-wrapper">
                                <Dropdown value={sort} options={sortOptions} onChange={(e) => setSort(e.value)} placeholder="Sort By" className="vault-sort-dropdown" />
							</div>
							<div className="customer-wrapper">
								<CustomerSelection />
							</div>
                        </div>
                    </div>
                </div>
                <CSSTransition in={!!activeFilter} timeout={300} classNames="filter-panel" unmountOnExit>
					<div className="filter-panel-container">
						{activeFilter && (
                        <motion.div
                            key={activeFilter}
                            className="filter-panel-inline"
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.25 }}
                        >
                            <div className="filter-panel-scroll">
								{activeFilter === "By Ring Style" && (
									<input
										type="text"
										className="ring-style-input"
										placeholder="Search Ring Style…"
										value={selectedFilters["By Ring Style"] || ""}
										onChange={(e) => updateFilter("By Ring Style", e.target.value)}
									/>
								)}
								{activeFilter === "Price" && (
									<div className="price-slider-wrapper">
										<div className="d-flex align-items-start gap-3">
											<div className="col-12 col-lg-4 col-md-4 col-sm-4">
												<div className="range-container mt-2">
													<input
														type="range"
														min={min}
														max={max}
														step={step}
														value={selectedPrice[0]}
														onChange={handleMinChange}
														className="range-slider range-min"
													/>
													<input
														type="range"
														min={min}
														max={max}
														step={step}
														value={selectedPrice[1]}
														onChange={handleMaxChange}
														className="range-slider range-max"
													/>
													<div
														className="slider-track"
														style={{ left: `${(selectedPrice[0] / max) * 100}%`, right: `${100 - (selectedPrice[1] / max) * 100}%` }}
													/>
												</div>
												<div className="d-flex justify-content-between mt-2">
													<span className="text-muted">₹ {selectedPrice[0].toLocaleString()}</span>
													<span className="text-muted">₹ {selectedPrice[1].toLocaleString()}</span>
												</div>
											</div>
											<div className="col-12 col-lg-4 col-md-8 col-sm-4">
												<div className="row g-2">
													<div className="col-4">
														<label className="form-label">From (₹)</label>
														<input
															type="number"
															className="form-control"
															value={priceInput.from}
															onChange={(e) => setPriceInput(p => ({ ...p, from: e.target.value }))}
															onBlur={() => {
																const from = clamp(+priceInput.from || min, min, max);
																const to = clamp(+priceInput.to || max, from, max);
																setSelectedPrice([from, to]);
																updateFilter("Price", { from, to });
															}}
															onKeyDown={(e) =>
																handleEnterApply(e, () => {
																	const from = clamp(+priceInput.from || min, min, max);
																	const to = clamp(+priceInput.to || max, from, max);
																	setSelectedPrice([from, to]);
																})
															}
														/>
													</div>
													<div className="col-4">
														<label className="form-label">To (₹)</label>
														<input
															type="number"
															className="form-control"
															value={priceInput.to}
															onChange={(e) => setPriceInput(p => ({ ...p, to: e.target.value }))}
															onBlur={() => {
																const from = clamp(+priceInput.from || min, min, max);
																const to = clamp(+priceInput.to || max, from, max);
																setSelectedPrice([from, to]);
																updateFilter("Price", { from, to });
															}}
															onKeyDown={(e) =>
																handleEnterApply(e, () => {
																	const from = clamp(+priceInput.from || min, min, max);
																	const to = clamp(+priceInput.to || max, from, max);
																	setSelectedPrice([from, to]);
																})
															}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}
								{activeFilter === "Gold Weight" && (
									<div className="price-slider-wrapper">
										<div className="d-flex align-items-start gap-3">
											<div className="col-12 col-lg-4 col-md-6">
												<div className="range-container mt-2">
													<input
														type="range"
														min={minGoldWeight}
														max={maxGoldWeight}
														step={stepGoldWeight}
														value={selectedGoldWeight[0]}
														onChange={handleGoldWeightMinChange}
														className="range-slider range-min"
													/>
													<input
														type="range"
														min={minGoldWeight}
														max={maxGoldWeight}
														step={stepGoldWeight}
														value={selectedGoldWeight[1]}
														onChange={handleGoldWeightMaxChange}
														className="range-slider range-max"
													/>
													<div
														className="slider-track"
														style={{ left: `${(selectedGoldWeight[0] / maxGoldWeight) * 100}%`, right: `${100 - (selectedGoldWeight[1] / maxGoldWeight) * 100}%` }}
													/>
												</div>
												<div className="d-flex justify-content-between mt-2">
													<span className="text-muted"> {selectedGoldWeight[0]} gm </span>
													<span className="text-muted"> {selectedGoldWeight[1]} gm </span>
												</div>
											</div>
											<div className="col-12 col-lg-6 col-md-6">
												<div className="row g-2">
													<div className="col-4">
														<label className="form-label">From (gm)</label>
														<input
															type="number"
															className="form-control"
															value={goldInput.from}
															onChange={(e) => setGoldInput(p => ({ ...p, from: e.target.value }))}
															onBlur={() => {
																const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																setSelectedGoldWeight([from, to]);
																updateFilter("Gold Weight", { from, to });
															}}
															onKeyDown={(e) =>
																handleEnterApply(e, () => {
																	const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																	const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																	setSelectedGoldWeight([from, to]);
																	updateFilter("Gold Weight", { from, to });
																})
															}
														/>
													</div>
													<div className="col-4">
														<label className="form-label">To (gm)</label>
														<input
															type="number"
															className="form-control"
															value={goldInput.to}
															onChange={(e) => setGoldInput(p => ({ ...p, to: e.target.value }))}
															onBlur={() => {
																const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																setSelectedGoldWeight([from, to]);
																updateFilter("Gold Weight", { from, to });
															}}
															onKeyDown={(e) =>
																handleEnterApply(e, () => {
																	const from = clamp(+goldInput.from || minGoldWeight, minGoldWeight, maxGoldWeight);
																	const to = clamp(+goldInput.to || maxGoldWeight, from, maxGoldWeight);
																	setSelectedGoldWeight([from, to]);
																	updateFilter("Gold Weight", { from, to });
																})
															}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}
								{activeFilter === "Carat" && (
									<div className="price-slider-wrapper">
										<div className="d-flex align-items-start gap-3">
											<div className="col-12 col-lg-4 col-md-4 col-sm-4">
												<div className="range-container mt-2">
													<input
														type="range"
														min={minCarat}
														max={maxCarat}
														step={stepCarat}
														value={selectedCarat[0]}
														onChange={handleCaratMinChange}
														className="range-slider range-min"
													/>
													<input
														type="range"
														min={minCarat}
														max={maxCarat}
														step={stepCarat}
														value={selectedCarat[1]}
														onChange={handleCaratMaxChange}
														className="range-slider range-max"
													/>
													<div
														className="slider-track"
														style={{ left: `${(selectedCarat[0] / maxCarat) * 100}%`, right: `${100 - (selectedCarat[1] / maxCarat) * 100}%` }}
													/>
												</div>
												<div className="d-flex justify-content-between mt-2">
													<span className="text-muted"> {selectedCarat[0]} ct </span>
													<span className="text-muted"> {selectedCarat[1]} ct </span>
												</div>
											</div>
											<div className="col-12 col-lg-4 col-md-8 col-sm-4">
												<div className="row g-2">
													<div className="col-4">
														<label className="form-label">From (ct)</label>
														<input
															type="number"
															className="form-control"
															value={caratInput.from}
															onChange={(e) => setCaratInput(p => ({ ...p, from: e.target.value }))}
															onBlur={() => {
																const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																setSelectedCarat([from, to]);
																updateFilter("Carat", { from, to });
															}}
															onKeyDown={(e) =>
																handleEnterApply(e, () => {
																	const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																	const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																	setSelectedCarat([from, to]);
																})
															}
														/>
													</div>
													<div className="col-4">
														<label className="form-label">To (ct)</label>
														<input
															type="number"
															className="form-control"
															value={caratInput.to}
															onChange={(e) => setCaratInput(p => ({ ...p, to: e.target.value }))}
															onBlur={() => {
																const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																setSelectedCarat([from, to]);
																updateFilter("Carat", { from, to });
															}}
															onKeyDown={(e) =>
																handleEnterApply(e, () => {
																	const from = clamp(+caratInput.from || minCarat, minCarat, maxCarat);
																	const to = clamp(+caratInput.to || maxCarat, from, maxCarat);
																	setSelectedCarat([from, to]);
																})
															}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}

								{activeFilter !== "By Ring Style" &&
									activeFilter !== "Price" &&
									activeFilter !== "Gold Weight" &&
									activeFilter !== "Carat" && (
										<div className="filter-grid-inline">
											{(() => {
												const options = filteredData[activeFilter] || [];
												const selectedValues = selectedFilters[activeFilter] || [];

												const allSelected =
													options.length > 0 &&
													selectedValues.length === options.length;

												return (
													<>
														<div className="form-check filter-option select-all-option">
															<input
																type="checkbox"
																className="form-check-input"
																id={`select-all-${activeFilter}`}
																checked={allSelected}
																onChange={() => {
																	if (allSelected) {
																		updateFilter(activeFilter, []);
																	} else {
																		updateFilter(activeFilter, [...options]);
																	}
																}}
															/>
															<label
																htmlFor={`select-all-${activeFilter}`}
																className="form-check-label fw-bold text-primary"
															>
																{allSelected ? "Deselect All" : "Select All"}
															</label>
														</div>

														{options.map(opt => {
															const checked = selectedValues.some(
																v => v.value === opt.value
															);

															return (
																<div key={opt.value} className="form-check filter-option">
																	<input
																		id={`filter-${activeFilter}-${opt.value}`}
																		className="form-check-input"
																		type="checkbox"
																		checked={checked}
																		onChange={() => {
																			updateFilter(
																				activeFilter,
																				checked
																					? selectedValues.filter(x => x.value !== opt.value)
																					: [...selectedValues, opt]
																			);
																		}}
																	/>
																	<label htmlFor={`filter-${activeFilter}-${opt.value}`} className={`form-check-label ${checked ? "fw-bold" : "" }`}>
																		{opt.label}
																	</label>
																</div>
															);
														})}
													</>
												);
											})()}
										</div>
									)}
                            </div>
                        </motion.div>
						)}
					</div>
                </CSSTransition>
				<div className="selected-tags-wrapper">
					{activeTags.length > 0 && (
						<button className="clear-all-btn" onClick={clearAllFilters}> Clear All × </button>
					)}
					{activeTags.map(tag => (
						<div key={tag.key} className="selected-tag">
							{tag.label} <span className="ms-1" onClick={() => removeTag(tag)}> ×</span>
						</div>
					))}
				</div>
            </div>
        </div>
    );
}